/**
 * API функции для работы с фильтрами заказов
 * Основано на endpoints из backend/app/api/filters/routes.py
 */

import { http } from './http'
import type { 
  ProcessingTypesResponse, 
  QuickFiltersResponse, 
  SyncFiltersRequest 
} from '../../types/filters'

export const filtersApi = {
  /**
   * Получить список типов обработки
   */
  async getProcessingTypes(source: 'default' | 'bitrix' = 'default'): Promise<ProcessingTypesResponse> {
    const response = await http.get(`/filters/processing-types?source=${source}`)
    return response.data
  },

  /**
   * Получить сохраненные быстрые фильтры пользователя
   */
  async getQuickFilters(): Promise<QuickFiltersResponse> {
    const response = await http.get('/filters/get-quick-filters')
    return response.data
  },

  /**
   * Синхронизировать быстрые фильтры с сервером
   */
  async syncQuickFilters(data: SyncFiltersRequest): Promise<{ success: boolean; filters: string[] }> {
    const response = await http.post('/filters/sync-quick-filters', data)
    return response.data
  }
}
